import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner2-1920x450.png";
import BottomLogoImg from "../assets/Images/bottom-logo.png";
import MainImg from "../assets/Images/mediation.png";
import TitleImg from "../assets/Images/title.png";
import ImageTextLayout from "../shared/ImageTextLayout";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./WhatIsMediationPage.scss";

const WhatIsMediationPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("what_is_mediation_page_header")}</h1>
          <p className="banner-subtitle">{t("what_is_mediation_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_what_is_mediation_page_link1")}</Link>
        <span>{t("breadcrumbs_what_is_mediation_page_span")}</span>
        <Link>{t("breadcrumbs_what_is_mediation_page_link2")}</Link>
      </Breadcrumbs>
      <ImageTextLayout
        image={MainImg}
        imageAlt="Mediation illustration"
        titleIcon={TitleImg}
        title={t("what_is_mediation_page_h3")}
      >
        <p>{t("what_is_mediation_page_text1")}</p>
      </ImageTextLayout>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" className="bottom-logo" />
      </div>
      <Footer />
    </>
  );
};

export default WhatIsMediationPage;
